import { Divider, Typography } from "antd";
import { OcppMessageLog } from "./OcppMessageLog";
import { TransactionLinkingPanel } from "./TransactionLinkingPanel";

export const OcppMessagesTab = ({ site_id }: { site_id: string }) => (
  <div className="w-full">
    <Typography.Title level={5}>Why is a badge not linked?</Typography.Title>
    <TransactionLinkingPanel site_id={site_id} />

    <Divider />

    <Typography.Title level={5}>Message log</Typography.Title>
    <Typography.Paragraph type="secondary">
      Every OCPP message the broker relayed for this site. Click a row to see
      the request next to its response.
    </Typography.Paragraph>
    <OcppMessageLog site_id={site_id} />
  </div>
);
